import { useState, useRef, useEffect } from "react";

export const useObserveElementWidth = <T extends HTMLElement>() => {
  const [width, setWidth] = useState(0);
  const ref = useRef<T>(null);
  const isMounted = useRef(true);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      if (isMounted.current) {
        setWidth(entries[0].contentRect.width);
      }
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      isMounted.current = false;
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return {
    width,
    ref,
  };
};
